import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import axios from "axios"
import { RootState } from "."
import { SavingsState, SavingsResponse } from "@/types/savings"

const state: SavingsState = {
    data: null,
    loading: false,
    error: null,
}

const mutations: MutationTree<SavingsState> = {
    SET_LOADING(state, loading: boolean) {
        state.loading = loading
    },
    SET_DATA(state, data: any) {
        state.data = data
    },
    SET_ERROR(state, error: string | null) {
        state.error = error
    },
}

const actions: ActionTree<SavingsState, RootState> = {
    async fetchSavings({ commit }, locationId: number) {
        commit("SET_LOADING", true)
        commit("SET_ERROR", null)

        try {
            const response = await axios.get<SavingsResponse>(
                `/locations/${locationId}/data/energy/savings`,
            )
            commit("SET_DATA", response.data.data)
        } catch (error: any) {
            commit("SET_ERROR", error.message || "Failed to fetch savings data")
        } finally {
            commit("SET_LOADING", false)
        }
    },
}

const getters: GetterTree<SavingsState, RootState> = {
    data: (state) => state.data,
    loading: (state) => state.loading,
    error: (state) => state.error,
}

const SavingsModule: Module<SavingsState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default SavingsModule
